import {useLayoutEffect, useRef} from "react";
import {getCachedImageUrl} from "../../../utils/utils";

type TmdbImageProps = {
    src: string;
    alt?: string;
    className?: string;
    style?: React.CSSProperties;
    isSpoiler?: boolean;
}

function CachedImage({src, alt, className, style, isSpoiler}: TmdbImageProps) {

    const imgRef = useRef<HTMLImageElement>(null);

    useLayoutEffect(() => {
        if (imgRef.current && isSpoiler) {
            imgRef.current.style.filter = `blur(${(imgRef.current.offsetWidth ?? 1000) * 0.05}px)`;
        }
    }, [isSpoiler, imgRef.current]);

    return (
        <img ref={imgRef} src={getCachedImageUrl(src)} alt={alt} className={className} style={{
            filter: isSpoiler ? "blur(100vw)" : "none",
            ...style
        }}/>
    )
}

export default CachedImage;
